import React, { useEffect, useState } from "react";
import { Col, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useQualityControls } from "../../../../../hooks/useDataHooks";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import ActionBar from "../../../../components/ActionBar";

const testType = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const testSpecified = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 12, xs: 12 };
const laboratory_tests = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const testsPerformed = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const testsPassed = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const testsFailed = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const witnessName = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };

const headerLayout = [
  { ...testType, header: "Type of Test" },
  { ...testSpecified, header: "Tests Specified" },
  { ...laboratory_tests, header: "Laboratory Name" },
  { ...testsPerformed, header: "Tests Performed" },
  { ...testsPassed, header: "Tests Passed" },
  { ...testsFailed, header: "Tests Failed" },
  { ...witnessName, header: "Witness Name" },
];

const QualityControls = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { qualityControls = [], pagination, loading: qualityControlLoading } =
    useQualityControls(packageId, startDate, endDate, currentPage, pageSize);

  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);

  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) {
      setPageSize(size);
    }
  };

  return (
    <>
      <div style={{ padding: "16px" }}>
        <ActionBar actionButtonProp={{
          title: `${packageName || "==//=="}: Quality Controls`,
        }} />
        <div className="prst-table">
        <CustomList
          itemName={`Quality Controls`}
          showToolbar={false}
          items={qualityControls || []}
          page={currentPage}
          itemCount={pagination?.total || (qualityControls?.length ?? 0)}
          loading={qualityControlLoading}
          headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id} // eslint-disable-line
              name={item?.sub_project?.name || "==//=="}
              item={item}
              isPackage={false}
              onClick={() => handleRowClick(item)}
              style={{
                backgroundColor:
                  activeItem?.id === item?.id ? "#f0f0f0" : "transparent",
              }}
            >
              <Col 
                {...testType} 
                className="contentEllipse"
                data-label="Type of Test"
              >
                {item.type_of_test?.length > 20 ? item.type_of_test.slice(0, 20) + "..." : item.type_of_test || "==//=="}
              </Col>

              <Col 
                {...testSpecified} 
                className="contentEllipse"
                data-label="Tests Specified"
              >
                {item?.number_of_tests_specified || "==//=="}
              </Col>

              <Col 
                {...laboratory_tests} 
                className="contentEllipse"
                data-label="Laboratory Name"
              >
                {item?.laboratory_name?.length > 40 ? item?.laboratory_name.slice(0, 40) + "..." : item?.laboratory_name || "==//=="}
              </Col>

              <Col 
                {...testsPerformed} 
                className="contentEllipse"
                data-label="Tests Performed"
              >
                {item?.number_of_tests_performed || "==//=="}
              </Col>

              <Col 
                {...testsPassed} 
                className="contentEllipse"
                data-label="Tests Passed"
              >
                {item?.number_of_tests_passed || "==//=="}
              </Col>

              <Col 
                {...testsFailed} 
                className="contentEllipse"
                data-label="Tests Failed"
              >
                {item?.number_of_tests_failed}
              </Col>

              <Col 
                {...witnessName} 
                className="contentEllipse"
                data-label="Witness Name"
              >
                {item?.witness_name?.length > 40 ? item?.witness_name.slice(0, 40) + "..." : item?.witness_name || "==//=="}
              </Col>
              
              <button 
                className="view-card-details" 
                onClick={() => handleRowClick(item)}
              >
                View Details
              </button>
            </ListItem>
          )}
        />
        </div>

        {pagination && (
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            loading={qualityControlLoading}
          />
        )}

        {activeItem && (
          <Drawer
            title={`Quality Controls`}
            placement="right"
            closable
            onClose={handleCloseDrawer}
            visible={visible}
            width={720}
          >
            <p>
              <strong>Type of Test:</strong> {activeItem?.type_of_test || "==//=="}
            </p>
            <p>
              <strong>Number of Tests Specified:</strong>{" "}
              {activeItem?.number_of_tests_specified || "==//=="}
            </p>
            <p>
              <strong>Laboratory Name:</strong>{" "}
                  {activeItem?.laboratory_name || "==//=="}
            </p>
            <p>
              <strong>Number of Tests Performed:</strong>{" "}
              {activeItem?.number_of_tests_performed || "==//=="}
            </p>
            <p>
              <strong>Number of Tests Passed:</strong>{" "}
              {activeItem?.number_of_tests_passed || "==//=="}
            </p>
            <p>
              <strong>Number of Tests Failed:</strong>{" "}
              {activeItem?.number_of_tests_failed || "0"}
            </p>
            <p>
              <strong>Witness Name:</strong> {activeItem?.witness_name || "==//=="}
            </p>
            <p>
              <strong>Remarks:</strong> {activeItem?.remarks || "==//=="}
            </p>
          </Drawer>
        )}
      </div>
    </>
  );
};

export default QualityControls;
